import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import {
  borderWidth,
  borderStyle,
  borderRadius as radius,
} from "../../../design-system/tokens/borders";
import { shadows } from "../../../design-system/tokens/shadows";

export const Container = styled.div<{ $compact?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${rawColors.structural.white};
  border-radius: ${({ $compact }) => ($compact ? radius.lg : radius.xl)};
  border: ${borderWidth[1]} ${borderStyle.solid} ${rawColors.grey[200]};
  box-shadow: ${shadows.component.card.control_panel};
  overflow: visible;
  padding: ${({ $compact }) => ($compact ? spacing[1] : `${spacing[1]} 0`)};
`;

export const ControlButton = styled.button<{ $compact?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ $compact }) => ($compact ? "32px" : "40px")};
  height: ${({ $compact }) => ($compact ? "32px" : "40px")};
  border: none;
  background: transparent;
  cursor: pointer;
  color: ${rawColors.text.mediumEmphasis};
  border-radius: ${radius.md};
  margin: ${spacing[1]};
  transition: background 0.15s ease, color 0.15s ease;

  &:hover {
    background: ${rawColors.grey[100]};
    color: ${rawColors.grey[900]};
  }

  &:active {
    background: ${rawColors.grey[200]};
  }
`;

export const Divider = styled.div`
  width: 24px;
  height: ${borderWidth[1]};
  background: ${rawColors.grey[200]};
  margin: ${spacing[1]} 0;
`;
